import { useRef } from "react";

function CTAButton({ page, position, style }) {
    const CTA = useRef();
    position = position?position:"fixed";
    console.log("Style -- ", {...style});
    return (false);

    //     ((page == "contact") || (!sessionStorage.getItem("hideCTA"))) && <div className={`CTA-cnt position-${position}`} style={{...style}} ref={CTA}>
    //         <img src="/Images/CTA-Button-Dutch.png" className="CTA-Image"></img>
    //         <div className="CTA-x-button" onClick={() => {
    //             CTA.current.style.display = "none";
    //             sessionStorage.setItem("hideCTA", true);
    //         }}>x</div>
    //     </div>

    // );
}
export default CTAButton;